export enum AlertDisplayType {
	Danger = "danger",
	Info = "info",
	Success = "success",
	Warning = "warning",
}